<div class="mainContainer">
    <div class="filter_show">
        <h2 class="log_track">Admin Reports</h2>
    </div>

    <div class="mess-box">
        <div class="mess-toolbar-row">
            <div class="overview-date-picker">
                <span class="overview-date-picker__label">Select date</span>
                <div class="overview-date-picker__wrap">
                    <div class="overview-date-picker__field">
                        <input type="text" class="overview-date-picker__input form-control" [value]="monthLabel"
                            readonly (click)="toggleOverviewPicker($event)" aria-label="Selected month and year" />
                        <button type="button" class="overview-date-picker__icon-btn"
                            (click)="toggleOverviewPicker($event)" [attr.aria-expanded]="overviewPickerOpen"
                            aria-label="Open year and month selection">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path
                                    d="M19 4h-1V2h-2v2H8V2H6v2H5C3.89 4 3 4.9 3 6v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"
                                    fill="currentColor" />
                            </svg>
                        </button>
                    </div>
                    <div class="overview-picker-card" *ngIf="overviewPickerOpen" role="dialog"
                        aria-label="Select year and month" (click)="$event.stopPropagation()">
                        <div class="overview-picker-card__header">
                            <button type="button" class="overview-picker-card__nav"
                                *ngIf="overviewPickerView === 'year'" (click)="prevYearPage()"
                                aria-label="Previous years">‹</button>
                            <button type="button" class="overview-picker-card__year-btn"
                                *ngIf="overviewPickerView === 'month'" (click)="showYearPickerView()"
                                aria-label="Change year">
                                {{ pickerYear }}
                            </button>
                            <span class="overview-picker-card__range" *ngIf="overviewPickerView === 'year'">
                                {{ yearPageStart }} – {{ yearPageEnd }}
                            </span>
                            <button type="button" class="overview-picker-card__nav"
                                *ngIf="overviewPickerView === 'year'" (click)="nextYearPage()"
                                aria-label="Next years">›</button>
                        </div>

                        <div class="overview-picker-card__years" *ngIf="overviewPickerView === 'year'">
                            <button type="button" class="overview-picker-card__cell" *ngFor="let y of yearPageYears"
                                [class.overview-picker-card__cell--active]="y === pickerYear"
                                (click)="selectPickerYear(y)">
                                {{ y }}
                            </button>
                        </div>

                        <div class="overview-picker-card__months" *ngIf="overviewPickerView === 'month'">
                            <button type="button" class="overview-picker-card__cell"
                                *ngFor="let m of monthPickerOptions"
                                [class.overview-picker-card__cell--active]="m.value === pickerMonth"
                                (click)="selectPickerMonth(m.value)">
                                {{ m.label }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="summary-cards">
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--closed" aria-hidden="true">
                        <i class="fa-solid fa-clipboard-check"></i>
                    </span>
                    <span class="summary-card__title">Closed</span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ monthlySummary.closed }}</span>
                    <span class="summary-card__trend" [class.summary-card__trend--up]="isSummaryTrendUp('closed')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('closed')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('closed') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        {{ summaryPercent(monthlySummary.closed) }}
                    </span>
                </div>
            </article>
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--pending" aria-hidden="true">
                        <i class="fa-solid fa-clock"></i>
                    </span>
                    <span class="summary-card__title">Pending </span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ monthlySummary.pending }}</span>
                    <span class="summary-card__trend" [class.summary-card__trend--up]="isSummaryTrendUp('pending')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('pending')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('pending') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        {{ summaryPercent(monthlySummary.pending) }}
                    </span>
                </div>
            </article>
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--not-submitted" aria-hidden="true">
                        <i class="fa-solid fa-circle-minus"></i>
                    </span>
                    <span class="summary-card__title">Not Submitted</span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ monthlySummary.notSubmitted }}</span>
                    <span class="summary-card__trend" [class.summary-card__trend--up]="isSummaryTrendUp('notSubmitted')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('notSubmitted')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('notSubmitted') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        {{ summaryPercent(monthlySummary.notSubmitted) }}
                    </span>
                </div>
            </article>
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--holiday" aria-hidden="true">
                        <i class="fa-solid fa-ban"></i>
                    </span>
                    <span class="summary-card__title">Holiday</span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ monthlySummary.holiday }}</span>
                    <span class="summary-card__trend" [class.summary-card__trend--up]="isSummaryTrendUp('holiday')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('holiday')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('holiday') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        {{ summaryPercent(monthlySummary.holiday) }}
                    </span>
                </div>
            </article>
            <article class="summary-card">
                <div class="summary-card__head">
                    <span class="summary-card__icon-wrap summary-card__icon-wrap--total" aria-hidden="true">
                        <i class="fa-solid fa-building"></i>
                    </span>
                    <span class="summary-card__title">Total Kitchens</span>
                </div>
                <div class="summary-card__foot">
                    <span class="summary-card__value">{{ totalKitchens }}</span>
                    <span class="summary-card__trend"
                        [class.summary-card__trend--up]="isSummaryTrendUp('totalKitchens')"
                        [class.summary-card__trend--down]="!isSummaryTrendUp('totalKitchens')">
                        <i class="fa-solid"
                            [ngClass]="isSummaryTrendUp('totalKitchens') ? 'fa-arrow-trend-up' : 'fa-arrow-trend-down'"></i>
                        Active
                    </span>
                </div>
            </article>
        </div>

        <div class="monthly-grid-wrap monthly-grid-wrap--active" *ngIf="divisions.length; else noDivisions">
            <div class="division-summary-table">
                <div class="division-summary-row division-summary-row--header">
                    <span class="division-summary-row__name">Division / Entity Summary</span>
                    <span class="division-summary-row__kitchens">Kitchens</span>
                    <span class="division-summary-row__stat division-summary-row__stat--closed">Approved</span>
                    <span class="division-summary-row__stat division-summary-row__stat--pending">Pending</span>
                    <span class="division-summary-row__stat division-summary-row__stat--holiday">Holiday</span>
                    <span class="division-summary-row__stat division-summary-row__stat--not-submitted">Not
                        Submitted</span>
                    <span class="division-summary-row__action">Action</span>
                </div>

                <section class="division-summary-block" *ngFor="let division of divisions; trackBy: trackDivision"
                    [class.division-summary-block--expanded]="division.expanded">
                    <button type="button" class="division-summary-row division-summary-row--division"
                        [class.division-summary-row--expanded]="division.expanded" (click)="toggleDivision(division)"
                        [attr.aria-expanded]="division.expanded">
                        <span class="division-summary-row__name">
                            <mat-icon class="division-summary-row__chevron">
                                {{ division.expanded ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                            <span>{{ division.divisionName }}</span>
                            <!-- <span class="division-summary-row__kitchen-badge">{{ division.kitchensCount }} Kitchens</span> -->
                        </span>
                        <span class="division-summary-row__kitchens">{{ division.kitchensCount }}
                            <small class="division-summary-row__kitchens-small">Kitchens</small>
                        </span>
                        <span class="division-summary-row__stat division-summary-row__stat--closed">
                            {{ division.summary.closed }}
                            <small>({{ summaryPercent(division.summary.closed, divisionSummaryTotal(division))
                                }})</small>
                        </span>
                        <span class="division-summary-row__stat division-summary-row__stat--pending">
                            {{ division.summary.pending }}
                            <small>({{ summaryPercent(division.summary.pending, divisionSummaryTotal(division))
                                }})</small>
                        </span>
                        <span class="division-summary-row__stat division-summary-row__stat--holiday">
                            {{ division.summary.holiday }}
                            <small>({{ summaryPercent(division.summary.holiday, divisionSummaryTotal(division))
                                }})</small>
                        </span>
                        <span class="division-summary-row__stat division-summary-row__stat--not-submitted">
                            {{ division.summary.notSubmitted }}
                            <small>({{ summaryPercent(division.summary.notSubmitted, divisionSummaryTotal(division))
                                }})</small>
                        </span>
                        <span class="division-summary-row__action">
                            <button type="button" class="division-summary-row__view-btn"
                                (click)="viewKitchens(division, $event)">
                                View Kitchens <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </button>
                        </span>
                    </button>

                    <div class="division-summary-entities" *ngIf="division.expanded">
                        <div
                            class="division-summary-row division-summary-row--entity division-summary-row--entity-header">
                            <span class="division-summary-row__name">Entity Code - Entity Name</span>
                            <span class="division-summary-row__kitchens">Kitchens</span>
                            <span class="division-summary-row__stat division-summary-row__stat--closed">Approved</span>
                            <span class="division-summary-row__stat division-summary-row__stat--pending">Pending</span>
                            <span class="division-summary-row__stat division-summary-row__stat--holiday">Holiday</span>
                            <span class="division-summary-row__stat division-summary-row__stat--not-submitted">Not
                                Submitted</span>
                            <span class="division-summary-row__action"></span>
                        </div>

                        <div class="division-summary-row division-summary-row--entity"
                            *ngFor="let entity of division.entities; trackBy: trackEntity">
                            <span class="division-summary-row__name">{{ entity.entityCode }}</span>
                            <span class="division-summary-row__kitchens">{{ entity.kitchensCount }}</span>
                            <span class="division-summary-row__stat division-summary-row__stat--closed">
                                {{ entity.summary.closed }}
                                <!-- <small>({{ summaryPercent(entity.summary.closed, entitySummaryTotal(entity)) }})</small> -->
                            </span>
                            <span class="division-summary-row__stat division-summary-row__stat--pending">
                                {{ entity.summary.pending }}
                                <!-- <small>({{ summaryPercent(entity.summary.pending, entitySummaryTotal(entity)) }})</small> -->
                            </span>
                            <span class="division-summary-row__stat division-summary-row__stat--holiday">
                                {{ entity.summary.holiday }}
                                <!-- <small>({{ summaryPercent(entity.summary.holiday, entitySummaryTotal(entity)) }})</small> -->
                            </span>
                            <span class="division-summary-row__stat division-summary-row__stat--not-submitted">
                                {{ entity.summary.notSubmitted }}
                                <!-- <small>({{ summaryPercent(entity.summary.notSubmitted, entitySummaryTotal(entity)) }})</small> -->
                            </span>
                            <span class="division-summary-row__action"></span>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <ng-template #noDivisions>
            <div class="do-office-empty">No division data found for {{ monthLabel }}.</div>
        </ng-template>
    </div>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>